import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitColumnsExtensionInterface } from '../../../extension/interface/benefit-columns.extension.interface';
import { BenefitInfoTextExtensionInterface } from '../../../extension/interface/benefit-info-text.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { KitaBenefitActivationDialogExtension } from './extension/kita-benefit-activation-dialog.extension';
import { KitaBenefitColumnsExtension } from './extension/kita-benefit-columns.extension';
import { KitaBenefitInfoTextExtension } from './extension/kita-benefit-info-text.extension';
import { KitaBenefitMetadataExtension } from './extension/kita-benefit-metadata.extension';
import { KitaBenefitNavigationExtension } from './extension/kita-benefit-navigation.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('kita')
    .add(BenefitMetadataExtensionInterface, new KitaBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new KitaBenefitNavigationExtension())
    .add(BenefitColumnsExtensionInterface, new KitaBenefitColumnsExtension())
    .add(BenefitActivationDialogExtensionInterface, new KitaBenefitActivationDialogExtension())
    .add(BenefitInfoTextExtensionInterface, new KitaBenefitInfoTextExtension())
    .build(),
);
